import { Section } from '@telegram-apps/telegram-ui';
import { TelegramTitle } from '../../components/shared/TelegramTitle';
import { RcaForm } from './RcaForm';
import { useLanguage } from '../../LanguageProvider';

export const Rca = () => {
  const { translate, setLanguage, language } = useLanguage();

  return (
    <>
      <div style={{ background: 'var(--tgui--secondary_bg_color)' }}>
        <TelegramTitle
          title={translate('rca-form:title')}
          subtitle={translate('rca-form:subtitle')}
        />
        <RcaForm />
      </div>
    </>
  );
};
